import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router';

import { FeatureFlag } from 'app/api/services/site-configs/types';

import { ModulesScrollbar } from 'app/design-system/components/Scrollbar';
import { asyncQueue } from 'app/lib/asyncQueue';
import useComponentWillMount from 'app/lib/hooks/useComponentWillMount';
import { selectSignalrConnected } from 'app/lib/signalr';
import { BettingMenu } from 'app/modules/BettingMenu';
import { isBettingMenu } from 'app/modules/BettingMenu/utils';
import { ServiceMenu } from 'app/modules/ServiceMenu';
import { useSSR } from 'app/packages/components/SkipSSR';

import { useLocalFeatureFlags } from '../../lib/feature-flags/useLocalFeatureFlags';
import { fetchLiveMainLine } from '../Live/actions';
import {
  LIVE_TOPIC,
  subscribe as liveSubscribe,
  unsubscribe as liveUnsubscribe,
} from '../Live/actions/liveHub';
import { entityRequested } from '../Live/selectors/entities';
import {
  PREMATCH_MAIN_LINE_TOPIC,
  subscribe as prematchSubscribe,
  unsubscribe as prematchUnsubscribe,
} from '../Prematch/actions';

import styles from './LeftMenu.module.scss';

export const LeftMenu: React.FC = () => {
  const isSSR = useSSR();
  const { hasFeatureFlag } = useLocalFeatureFlags();
  const isANTLR = hasFeatureFlag(FeatureFlag.ANTLR);
  const { pathname } = useLocation();
  const dispatch = useDispatch();
  const signalrConnected = useSelector(selectSignalrConnected);
  const requested = useSelector(entityRequested);

  useComponentWillMount(() => {
    if (isSSR && !requested) {
      dispatch(fetchLiveMainLine(isANTLR));
    }
  });

  useEffect(() => {
    if (signalrConnected) {
      asyncQueue.addToQueue(LIVE_TOPIC, () => dispatch(liveSubscribe()));
    }

    if (signalrConnected) {
      asyncQueue.addToQueue(PREMATCH_MAIN_LINE_TOPIC, () => dispatch(prematchSubscribe()));
    }
  }, [signalrConnected]);

  useEffect(() => {
    return () => {
      asyncQueue.removeFromQueue(
        LIVE_TOPIC,
        () => dispatch(liveUnsubscribe(),
        ), 5000);

      asyncQueue.removeFromQueue(
        PREMATCH_MAIN_LINE_TOPIC,
        () => dispatch(prematchUnsubscribe(),
        ), 5000);
    };
  }, []);

  return (
    <ModulesScrollbar className={styles.scrollbar}>
      {isBettingMenu(pathname) ? (
        <BettingMenu />
      ) : (
        <ServiceMenu />
      )}
    </ModulesScrollbar>
  );
};
